import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteRow, listCollection, type Row } from '../../lib/db';
import { useToast } from '../../components/Toast';

const GROUPS = ['employers', 'candidates', 'about'];

export function FaqList() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);
  const { notify } = useToast();

  const load = () =>
    listCollection('faqs').then((r) => {
      setRows(r);
      setLoading(false);
    });
  useEffect(() => {
    void load();
  }, []);

  const remove = async (id: string) => {
    if (!confirm('Delete this question?')) return;
    await deleteRow('faqs', id);
    notify('success', 'Deleted.');
    void load();
  };

  const sorted = rows.slice().sort(
    (a, b) =>
      GROUPS.indexOf(String(a.group)) - GROUPS.indexOf(String(b.group)) ||
      Number(a.order ?? 0) - Number(b.order ?? 0),
  );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">FAQs</h3>
        <Link to="/faqs/new" className="btn btn-success btn-sm">New question</Link>
      </div>
      <p className="text-muted small">Shown on /faq (grouped), and on the homepage when &quot;Show on homepage&quot; is ticked.</p>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover align-middle">
          <thead>
            <tr><th>Group</th><th>#</th><th>Question (EN)</th><th>Home</th><th>Status</th><th /></tr>
          </thead>
          <tbody>
            {sorted.map((r) => {
              const q = (r.q ?? {}) as { en?: string; bg?: string };
              return (
                <tr key={r.id}>
                  <td>{String(r.group ?? '')}</td>
                  <td>{String(r.order ?? '')}</td>
                  <td>{q.en || q.bg}</td>
                  <td>{r.onHome ? '✓' : ''}</td>
                  <td><span className={`badge ${r.status === 'published' ? 'bg-success' : 'bg-secondary'}`}>{String(r.status ?? 'draft')}</span></td>
                  <td className="text-end">
                    <Link to={`/faqs/${r.id}`} className="btn btn-sm btn-outline-secondary me-2">Edit</Link>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => remove(r.id)}>Delete</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
